// Region page functionality
document.addEventListener("turbolinks:load", () => {
  // Only run if we're on a regions page
  if (
    !document.querySelector('[data-page="regions-show"]') &&
    !document.querySelector(".swiper-data")
  ) {
    return;
  }

  // Trigger USA model ready event if not already loaded
  if (typeof window.aianta === "undefined" || !window.aianta.Usa) {
    $(document).trigger("usa-model:ready");
  }

  const experienceCount = $(".swiper-data").data("count");

  if (experienceCount > 0) {
    // Initialize swiper if aianta.Swipermodel exists
    if (window.aianta && window.aianta.Swipermodel) {
      const swiper = new window.aianta.Swipermodel({
        slideChangeAnimation: true,
      });
      swiper.setupSwiper();
      swiper.setupListener();
    }
  } else {
    $(".swiper-button-next, .swiper-button-prev").hide();
  }

  // Hide opened headers initially
  $(".header_opened").hide();

  // Tribe accordion toggle
  $("#tribe-accordian_toggle")
    .off("click")
    .on("click", function (e) {
      e.preventDefault();
      $("#tribe-accordian-bottom .accordian_is_hidden").toggle();
      $("#tribe-accordian-bottom .header_closed").toggle();
      $("#tribe-accordian-bottom .header_opened").toggle();
    });

  // Listing accordion toggle
  $("#listing-accordian_toggle")
    .off("click")
    .on("click", function (e) {
      e.preventDefault();
      $("#listing-accordian-bottom .accordian_is_hidden").toggle();
      $("#listing-accordian-bottom .header_closed").toggle();
      $("#listing-accordian-bottom .header_opened").toggle();
    });

  // Helper functions for accordion animations
  const toggleAll = () => {
    $(".accordian-toggle-height").each((i, obj) => {
      toggleHeight(obj);
    });
  };

  const toggleHeight = (jqObj) => {
    $(jqObj).animate({
      height: "toggle",
    });
  };

  // Export functions to global scope if needed
  window.regionHelpers = {
    toggleAll,
    toggleHeight,
  };
});

// Also trigger on document ready as fallback
$(document).ready(() => {
  $(document).trigger("regions-show:ready");
});
